if(!customElements.get('made-in')) {
    class MadeIn extends HTMLElement {
        constructor() {
            super();
        }
        async connectedCallback() {
            this.selectors = {
                usa: this.querySelector('.usa'),
                denmark: this.querySelector('.denmark')
            }
            await fetch('/browsing_context_suggestions.json')
            .then(response => response.json())
            .then(response => {
                if(response?.detected_values?.country?.handle === 'US') {
                    this.selectors.usa.classList.add('active');
                    this.selectors.denmark.classList.remove('active');
                } else {
                    this.selectors.denmark.classList.add('active');
                    this.selectors.usa.classList.remove('active');
                }
            })
        }
    }
    customElements.define('made-in', MadeIn);
}